// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2KR3e","search":"Settings_search__1O7E5","filter":"Settings_filter__2wDVG"};